export default __webpack_public_path__ + "static/media/energy.956c0f43.png";